import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCalls = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 28" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#4D4D4D">
      <path d="M26.98 3.71a436.4 436.4 0 0 1 1.593 1.424c1.203 1.07 1.397 2.585.582 4.544-1.221 2.938-5.803 10.023-15.782 16.012-2.201 1.548-4.179 1.2-5.087 0-.605-.8-1.2-1.566-1.78-2.298-.647-.998-.375-1.924.815-2.778 1.785-1.281 1.214-.83 2.673-1.829 1.458-1 1.445-.776 3.38 0 1.934.776 1.952 1.453 3.868-.376 1.278-1.22 2.915-2.886 4.911-5 .749-.703.749-1.58 0-2.633-1.124-1.578-1.123-2.184 0-3.913a32.756 32.756 0 0 1 2.312-3.153c.832-.754 1.67-.754 2.516 0z" />
      <g transform="translate(1 1)">
        <circle cx={6} cy={6} r={6} />
        <path d="M3.8 3.047 6.278 6.44h3.025" />
      </g>
    </g>
  </svg>
);
const Memo = memo(SvgCalls);
export default Memo;
